import { useEffect, useState } from 'preact/hooks';
import { fetchAccount, fetchContentfulData } from '../utils/api';

const useNavContent = (contentId, apiHost) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const contentfulData = await fetchContentfulData(contentId);
      const modifiedContentfulData = await fetchAccount(contentfulData, apiHost);
      setData(modifiedContentfulData);
    };

    fetchData();
  }, [apiHost, contentId]);

  return data;
};

export default useNavContent;
